export const PAGE_DETAILS = {
  MaintenanceSchedule: {
    // Page
    PageTitle: 'Maintenance Schedule',

    // Buttons
    CreateButton: 'Add New Rule',

    // Dialogs
    DeleteConfirmationTitle: 'Delete Maintenance Schedule',
    DeleteConfirmationMessage:
      'Are you sure you want to delete the selected maintenance schedule?',

    // List Columns
    ListColumnIDLabel: 'ID',
    ListColumnStartDateLabel: 'Start date',
    ListColumnEndDateLabel: 'End date',
    ListColumnTabCodeLabel: 'Tab codes',
    ListColumnPmIdLabel: 'Payment Method IDs',
    ListColumnCreatedByLabel: 'Created By',

    // Fields
    FieldStartDate: 'Enter start date',
    FieldEndDate: 'Enter end date',
    FieldTabCode: 'Enter tab code',
    FieldPaymentMethodId: 'Enter payment method id',
    FieldSelectType: 'Select type',
    FieldStartDateTime: 'Select start datetime',
    FieldEndDateTime: 'Select end datetime',
    FieldTabCodesTitle: 'Tab codes',
    FieldTabCodesTooltip: 'Add a new Tab Code',
    FieldPmIdTitle: 'Payment method ids',
    FieldPmIdTooltip: 'Add a new Payment Method ID',

    // Validations
    RequiredField: 'Required field',

    // API Actions
    CreateSuccess: 'Yay! Maintenance schedule has been created successfully.',
    CreateFailure:
      'Oops! Something went wrong while creating the maintenance schedule.',

    DeleteSuccess: 'Yay! Maintenance schedule has been deleted successfully.',
    DeleteFailure:
      'Oops! Something went wrong while deleting the maintenance schedule.',
  },
};

export const COLUMN_WIDTH = {
  XM: 50,
  SM: 100,
  MD: 150,
  LG: 200,
  XL: 250,
  XXL: 350,
  XXXL: 550,
};

export const MAINTENANCE_SCHEDULE_COLUMNS = [
  {
    field: 'id',
    width: COLUMN_WIDTH.XM,
    align: 'center',
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnIDLabel,
  },
  {
    field: 'startDateTime',
    align: 'center',
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnStartDateLabel,
  },
  {
    field: 'endDateTime',
    align: 'center',
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnEndDateLabel,
  },
  {
    field: 'tabCodes',
    align: 'center',
    flex: 1,
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnTabCodeLabel,
  },
  {
    field: 'pmids',
    align: 'center',
    flex: 1,
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnPmIdLabel,
  },
  {
    field: 'createdBy',
    width: COLUMN_WIDTH.XL,
    headerName: PAGE_DETAILS.MaintenanceSchedule.ListColumnCreatedByLabel,
  },
];

export const CONTEXTUAL_MESSAGE_COLUMNS = [
  {
    field: 'webUrl',
    headerName: 'Web Url',
    width: COLUMN_WIDTH.XL,
  },
  {
    field: 'mobUrl',
    headerName: 'Mob Url',
    width: COLUMN_WIDTH.XL,
  },
  {
    field: 'message',
    headerName: 'Message',
  },
  {
    field: 'translationKey',
    headerName: 'Translation Key',
  },
  {
    field: 'bannerPlacement',
    headerName: 'Banner Placement',
  },
  {
    field: 'priority',
    headerName: 'Priority',
  },
  {
    field: 'bannerType',
    headerName: 'Banner Type',
  },
  {
    field: 'tiedToPromotionCode',
    headerName: 'Tied To Promotion Code',
  },
  {
    field: 'transactionCurrency',
    headerName: 'Transaction Currency',
  },
  {
    field: 'locale',
    headerName: 'Locale',
  },
  {
    field: 'keepAlways',
    headerName: 'Keep Always',
  },
  {
    field: 'startDateTime',
    headerName: 'Start Time',
  },
  {
    field: 'endDateTime',
    headerName: 'End Time',
  },
  {
    field: 'user',
    headerName: 'User',
  },
];

export const CONFIG_MODULE_LIST = [
  {
    name: 'Backend Configuration',
    stgPath: 'payments_backend-configuration_value_file.json',
    prdPath: 'payments_backend-configuration_value_file.json',
  },
  {
    name: 'Bin Range',
    stgPath: 'payments_config_binrange_file.json',
    prdPath: 'payments_config_binrange_file.json',
  },
  {
    name: 'Bin Settings',
    stgPath: 'payments_config_binsettings_file.json',
    prdPath: 'payments_config_binsettings_file.json',
  },
  {
    name: 'Carrier Code',
    stgPath: 'jace-admin_carrier-code',
    prdPath: 'jace-admin_carrier-code',
  },
  {
    name: 'Culture Code',
    stgPath: 'jace-admin_culture-code',
    prdPath: 'jace-admin_culture-code',
  },
  {
    name: 'Currency Code',
    stgPath: 'jace-admin_currency-code',
    prdPath: 'jace-admin_currency-code',
  },
  {
    name: 'Payment Channel',
    stgPath: 'jace-admin_payment-channel',
    prdPath: 'jace-admin_payment-channel',
  },
  {
    name: 'Payment Tab',
    stgPath: 'jace-admin_payment-tab',
    prdPath: 'jace-admin_payment-tab',
  },
];

export const CacheReloadConfigs = [
  {
    name: 'Oms Payment Redirect',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.lookup.payopt.control',
        value:
          '27760fe33f18f123c084d1e81c512a95079cb87e328b0662f7949763dfa2d66a',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_oms-payment-redirect',
      },
    ],
  },
  {
    name: 'Payment Switchv2',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.switch',
        value:
          'e597d7b71596fecd96712064bd893b54dd86938ba64855efc132bc777abecdc1',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_payment_switchv2',
      },
    ],
  },
  {
    name: 'Currency Details',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.currencydetails',
        value:
          '6c28d1632f26b59b7b90614974388ad6a601ac2bfea6e27910c3a68be50078ea',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_currency_details_config',
      },
    ],
  },
  {
    name: 'Currency Culture Carrier Code',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.lookup.getsettingfile',
        value:
          '8cd99b6544d13e467b1739fcb5e6f927b30730dd9d1f400d47034a556c385e53',
      },
    ],
  },
  {
    name: 'Mcc Restriction',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.lookup.payopt.control',
        value:
          '42a5df5f9934711e4691f91cef015a0d9585539d6fbfa9dc4980ec81d06bbd05',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_mcc_restriction',
      },
    ],
  },
  {
    name: 'Externalmpi Reroute',
    items: [
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_externalmpi_reroute',
      },
    ],
  },
  {
    name: 'Backend Configuration',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.payment.config',
        value:
          '9b50c6bd412d8e4c09a33a8f661f1c9c3217557f165a3f42568aaee625f724e8',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_backend_configurationV2',
      },
    ],
  },
  {
    name: 'Promotion Discount',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.promotiondiscount',
        value:
          '69d869b12b7adeb9806438a21115bf98c99083b45f77de249330ddd7b455ae16',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_promotion_discount_config',
      },
    ],
  },
  {
    name: 'Move Promotion Discount',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.payment.config',
        value:
          '6225f72f59bc8345a84d2d2158c908e28e110b91ad42f8ea463ec9d0d9b78da5',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_move_promotion_discount_config',
      },
    ],
  },
  {
    name: 'Revenue Bond',
    items: [
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_revenue_bond',
      },
    ],
  },
  {
    name: 'Cashflow Redirect Methods',
    items: [
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_payment_cashflow_method_config',
      },
    ],
  },
  {
    name: 'Bin Settings',
    items: [
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_bin_settings_config',
      },
    ],
  },
  {
    name: 'Get Payment Tab',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.payment.config',
        value:
          '1a3fea4d4c88e1fdbf6708d292e0b30b5f1a6de73240a34d55cad1c79b905f86',
      },
    ],
  },
  {
    name: 'Fee Code',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.feecode',
        value:
          '9a6a63ddf99227155e642cd2dda1174a742a9241d41b8eb4f340546301fd9930',
      },
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_fee_code_config',
      },
    ],
  },
  {
    name: 'Promocode Msg',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.payment.config',
        value:
          '62870c6a8855b29aed8a2962fc3b4001b28925744f022aa872892f8829d9b71e',
      },
    ],
  },
  {
    name: 'Contextual Message',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.payment.config',
        value:
          '62a1d974020e01949de2ff0a3da575631d63eb3890e8d587a90a5e2ed0151009',
      },
    ],
  },
  {
    name: 'Bpwallet Config',
    items: [
      {
        name: 'DS',
        namespace: 'airasia.com.deeplink.lookup.payopt.control',
        value:
          '16058c9a646ea237ea677936cfeb2f7c5c8817dddfa59bd19f49ee6ca71045b3',
      },
    ],
  },
  {
    name: 'Ifg Client Id',
    items: [
      {
        name: 'PS',
        namespace: 'COM.PAYMENTS.CONFIG.DETAILS',
        value: 'payment_config_ifg_client_id',
      },
    ],
  },
];
